<template>
  <div class="layout">
    <template v-if="!allShow.includes($route.path)">
      <TopNav style="z-index: 31;" :classWidth="classWidth" :classBackground="classBackground"></TopNav>
      <TopSearch v-if="!TopSearchShowArr.includes($route.name)"></TopSearch>
      <SecondNav v-if="isSecondNav.includes($route.path)"/>
    </template>
    <div class="main">
      <router-view></router-view>
    </div>
     <!-- 侧边栏 -->
     <fixedBar class="fixed-bar" :class="{ 'show-fixed': !$store.state.showLogin }"></fixedBar>
    <!-- <Footer></Footer> -->
    <div class="showTheLogin"></div>
  </div>
</template>
<script>
import Vue from 'vue'
import Footer from '@/components/base/footer'
import TopNav from '@/components/base/topNav'
import TopSearch from '@/components/base/topSearch'
import SecondNav from '@/components/base/secondNav.vue'
import Login from '@/views/login/login.vue'
import fixedBar from '@/components/fixed/index'

export default {
  name: 'layout',
  components: {TopNav, Footer, Login, TopSearch, SecondNav, fixedBar},
  data () {
    return {
      dom: null,
      classWidth: '',
      classBackground: '',
      topNavClassArr: ['index', 'productDetail', 'search', 'store', 'category'],
      TopSearchShowArr: ['index', 'search', 'store', 'productDetail', 'category'],
      isSecondNav: ['/activity/search', '/activity/category'],
      allShow: ['/PromotionPage', '/knowledgeRule', '/liveStreamingRoom','/foodZone','/costume','/specialOffer','/information','/informationDetails'],
      isTopSearch: true,
    }
  },
  watch: {
    '$store.state.showLogin': {
      handler (nVal, oVal) {
        if (nVal) {
          const LoginCom = Vue.extend(Login)
          if (document.getElementsByClassName('showTheLogin').length > 0) {
            this.dom = new LoginCom().$mount('.showTheLogin')
          }
          if (document.getElementsByClassName('hiddenLogin').length > 0) {
            this.dom = new LoginCom().$mount('.hiddenLogin')
          }
        } else {
          if (this.dom) {
            document.getElementsByClassName('showTheLogin')[0].setAttribute('class', 'hiddenLogin')
          }
        }
      }
    },
    '$route': {
      handler (to, from) {
        this.topNavClassMtd()
      }
    }
  },
  created () {
    this.topNavClassMtd()
  },
  methods: {
    topNavClassMtd () {
      if (this.topNavClassArr.includes(this.$route.name)) {
          this.classWidth = 'width_auto'
          this.classBackground = 'background_FFF'
        } else {
          this.classWidth = 'width_1200'
          this.classBackground = 'background_D6DBE3'
        }
    },
  },
}
</script>
<style scoped lang='scss'>
.layout{
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  // position: relative;
  .main{
    flex: 1;
    background-color: #f4f8fe;
    min-width: 1200px;
  }
}
.hiddenLogin{
  animation: hiddenRight 1s;
  animation-fill-mode:forwards;
  -webkit-animation-fill-mode:forwards;
}
@keyframes hiddenRight {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout.vue